module.exports = "div.main-container {\n    max-width: 800px;\n    background: #FFFFFF;\n    padding: 0 20px;\n    border-radius: 5px;\n    margin: 10px auto 10px auto;\n}\n\ndiv.heading {\n    padding-bottom: 10px;\n}\n\ndiv.heading > h3 {\n    margin-top: 10px;\n}\n\ndiv.buttons-row {\n  margin-bottom: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account-create/account-create.component.css
// module id = ./src/app/components/account-create/account-create.component.css
// module chunks = main